export default class Locale_EntityPropertyFilter { 
	Delete = {
		Grouping: "Delete grouping",
		Expression: "Delete expression"
	}
	SelectProperty: string = "Select property";
	SelectPropertyPlaceholder: string = "Select property";
	Group: string = "Group";
}